<template>
	<div>

		<!--		<div v-if="true">-->
		<!--			<b>Billing</b>-->
		<!--			<div class="row mx-0 align-items-center my-4 text-center">-->
		<!--				<div class="col">-->
		<!--					<div class="mb-2">Please add at least one method for your client to pay.</div>-->
		<!--					<div class="mb-4">-->
		<!--						<small class="text-muted">Allow your clients to pay using credit card, PayPal or set the instructions to manually pay invoices.</small>-->
		<!--					</div>-->
		<!--					<el-button class="" type="primary" size="small">Add payment method</el-button>-->
		<!--				</div>-->
		<!--			</div>-->
		<!--		</div>-->

		<div class="relative">
			<div v-if="!hideTitle" class="row align-items-center justify-content-center mx-0 mb-4">
				<b>Billing</b>
				<div class="layout-spacer"></div>
				<el-switch class="ml-2 el-switch-always-on"
						   v-model="paymentTypeIsFixed"
						   inactive-text="Recurring"
						   active-text="Fixed"
						   @change="onBillingTypeChanged"></el-switch>
			</div>

			<!--							<input v-model="time.start"-->
			<!--								   class="col el-input__inner default-padding"-->

			<component
				ref="componentPanel"
				v-if="billingData"
				:is="paymentTypePanelName"
				:billing-data="billingData"
				:invoices="invoices"
				:programItem="programItem"
				:hidePaymentMethodsView="hidePaymentMethodsView"
				:is-saving-billing-data="isSavingBillingData"
				:modal="modal"
				:modalSize="modalSize"
				:clients="clients"
				@onDataChanged="onDataChanged"
				v-bind="$attrs"/>



		</div>



	</div>
</template>

<script>

import BillingData, {BillingType} from "@shared/Billing/BillingData";
import BillingItem, {MilestoneType, PaymentStatus} from "@shared/Billing/BillingItem";
import moment from 'moment'
import CoachingProgram from "@shared/Program/CoachingProgram";

import SavingIndicator from "@/core/components/SavingIndicator.vue"


import {deleteConfirmDialog} from '@/core/components/Dialogs/dialog'

import ConfirmedPaymentDialog from './Dialogs/ConfirmedPaymentDialog'
import InvoiceDetailsDialog from './Dialogs/InvoiceDetailsDialog'
import CreateInvoiceDialog from './Dialogs/CreateInvoiceDialog'
import EditTimeEntryDialog from './Dialogs/EditTimeEntryDialog'
import TimeEntryInput from './TimeEntryInput'
import {InvoiceCommand} from "@shared/Invoice/InvoiceItem";

import InvoiceGroup from "@shared/Invoice/InvoiceGroup";
import PersonItem from "@shared/Invoice/PersonItem";
import PaymentMethodsManageView from "@/core/modules/coach/Coaching/Panels/ProgramBilling/PaymentMethodsManageView.vue";

let confirmedPaymentDialog = createDialogLazy(ConfirmedPaymentDialog)
let invoiceDetailsDialog = createDialogLazy(InvoiceDetailsDialog)
let createInvoiceDialog = createDialogLazy(CreateInvoiceDialog)

let editTimeEntryDialog = createDialogLazy(EditTimeEntryDialog)


import BaseComponent from "@/core/components/BaseComponent.vue";
import QwInput from "@/core/components/Controls/QwInput.vue";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
import FixedPaymentTypePanel
	from "@/core/modules/coach/Coaching/Panels/ProgramBilling/PaymentTypes/FixedPaymentTypePanel.vue";
import RecurringPaymentTypePanel
	from "@/core/modules/coach/Coaching/Panels/ProgramBilling/PaymentTypes/RecurringPaymentTypePanel.vue";
import HourlyPaymentTypePanel
	from "@/core/modules/coach/Coaching/Panels/ProgramBilling/PaymentTypes/HourlyPaymentTypePanel.vue";
import {createDialogLazy} from "@/utils/helpers-external.js";

export default {
	extends: BaseComponent,
	name: "ProgramBillingPanel",
	components: {
		HourlyPaymentTypePanel,
		RecurringPaymentTypePanel,
		FixedPaymentTypePanel,
		ToolTipView,
		QwInput,
		PaymentMethodsManageView,
		SavingIndicator,
		TimeEntryInput
	},
	props: {
		data: BillingData,
		programItem: CoachingProgram,
		invoices: {type: Array, default: () => []},
		disableInvoices: {type: Boolean, default: false},
		clients: Array,
		modal: {Boolean, default: true},
		modalSize: String,
		hidePaymentMethodsView: Boolean,
		hideTitle: Boolean
	},
	watch: {
		data: {
			immediate: true,
			handler(newVal, oldVal) {
				this.billingData = newVal
				this.paymentTypeIsFixed = this.billingData.isFixed()
				console.log("programbilling data: ", this.data)
				console.log("programbilling invoices: ", this.invoices)

			},
		},
	},
	data: () => {
		return {
			billingData: new BillingData(),
			isSavingBillingData: false,
			isEmitDataChangePending: false,
			showPaymentMethodsOptions: false,
			paymentTypeIsFixed: true
		}
	},

	created() {
		// this.emitDataChangeDebounced = debounce(this.emitDataChange, 5000)
	},
	beforeUnmount() {
		console.log("ProgramBilling: beforeUnmount")
		if (this.isEmitDataChangePending) {
			this.emitDataChange()
		}
	},

	methods: {
		async validate(){
			return this.$refs.componentPanel.validate()
		},
		isProgramStepAlreadyUsed(step) {
			return this.billingData.findBillingItemByMilestoneSectionId(step.id) != null
		},
		onBillingItemRowClicked(billingItem, invoiceGroup) {
			console.log("onBillingItemRowClicked: billingItem = ", billingItem, ", invoiceGroup = ", invoiceGroup)
			invoiceGroup = invoiceGroup || this.findInvoiceGroupForBillingItemId(billingItem.id)
			if (invoiceGroup.isPaid()) {
				this.onConfirmedPaymentClicked(billingItem)
			} else if (invoiceGroup.isInvoiced() || invoiceGroup.isConfirmPending()) {
				this.onManualPaymentConfirmClicked(billingItem)
			}
		},
		onConfirmedPaymentClicked(billingItem) {
			let invoiceGroup = this.findInvoiceGroupForBillingItemId(billingItem.id)
			console.log("onConfirmedPaymentClicked: invoiceGroup = ", invoiceGroup)
			console.log("onConfirmedPaymentClicked: billingItem = ", billingItem)
			console.log("onConfirmedPaymentClicked: this.invoices = ", this.invoices)
			confirmedPaymentDialog(this.billingData, billingItem, invoiceGroup)
				.then(data => {
					if (data.command == InvoiceCommand.REMOVE_PAID) {
						invoiceGroup.setPaymentStatus(PaymentStatus.INVOICED)
						this.onInvoiceChanged(invoiceGroup)
						this.onDataChanged()
					}
				})

		},
		async onSendInvoiceClicked(billingItem) {
			let _ = this.$analyticManager.trackEvent("Create invoice clicked", this.analyticsPropsMethod())
			console.log("onSendInvoiceClicked111")

			let invoiceData = await createInvoiceDialog({
				billingData: this.billingData,
				billingItem: billingItem,
				clients: this.clients,
				invoiceGroupList: this.invoices,
				programItem: this.programItem
			})

			if (invoiceData) {
				let invoiceGroup = invoiceData.invoiceGroup;
				let isConfirmManually = invoiceData.isConfirmManually
				let status = isConfirmManually ? PaymentStatus.PAID : PaymentStatus.INVOICED
				invoiceGroup.setPaymentStatus(status, new Date().getTime())
				this.onInvoiceChanged(invoiceGroup)
				this.onDataChanged()
			}

		},

		async onTimeEntryEditClicked(billingItem) {
			let _ = this.$analyticManager.trackEvent("Time entry edit clicked", this.analyticsPropsMethod())
			let data = await editTimeEntryDialog({
				billingData: this.billingData,
				billingItem: billingItem
			})
			if (data) {
				this.onDataChanged()
			}
		},
		findInvoiceGroupForBillingItemId(billingItemId) {
			// console.log("billingItemId = ", billingItemId)
			let group = this.invoices.find(invoiceGroup => invoiceGroup.findInvoiceByBillingItemId(billingItemId))
			// console.log("group = ", group)
			return group
		},


		clientsToPersonItems() {
			return this.clients.map(client => new PersonItem(client.id, client.name, client.email))
		},

		async onManualPaymentConfirmClicked(billingItem) {
			let _ = this.$analyticManager.trackEvent("Manual payment confirm clicked", this.analyticsPropsMethod())
			let paidDate = new Date();

			let invoiceGroup = this.findInvoiceGroupForBillingItemId(billingItem.id)
			if (invoiceGroup) {
				let paidDateTs = invoiceGroup.paidDateTsIfAllSame()
				if (paidDateTs) {
					paidDateTs = new Date(paidDateTs)
				}
			}

			let data = await invoiceDetailsDialog(this.billingData, billingItem, invoiceGroup, paidDate)
			console.log("paidConfirmDialog: data = ", data)
			if (!data) {
				return
			}
			let paidDateTs = data.paidDate.getTime()
			let command = data.command;
			switch (command) {
				case InvoiceCommand.CONFIRM: {
					invoiceGroup.setPaymentStatus(PaymentStatus.PAID, paidDateTs)
					this.onInvoiceChanged(invoiceGroup)
					break;
				}
				case InvoiceCommand.CREATE_CONFIRMED: {
					let invoiceGroup = new InvoiceGroup();
					invoiceGroup.createInvoiceForAll(this.clientsToPersonItems(), this.billingData, [billingItem.id], this.currencyItemGlobal)
					invoiceGroup.setBillFrom(new PersonItem(this.userProfile.id, this.userProfile.name, this.userProfile.email))
					invoiceGroup.setPaymentStatus(PaymentStatus.PAID, paidDateTs)
					invoiceGroup.setIsEmailSent(true)
					this.onInvoiceChanged(invoiceGroup)
					break;
				}
				case InvoiceCommand.CREATE:
					await this.onSendInvoiceClicked(billingItem)
					break;
				case InvoiceCommand.WITHDRAW: {
					invoiceGroup.setPaymentStatus(PaymentStatus.DELETED)
					this.onInvoiceChanged(invoiceGroup)
					break;
				}
			}
			this.onDataChanged()

		},
		async onDeleteMilestoneClicked(billingItem) {
			let _ = this.$analyticManager.trackEvent("Delete payment milestone clicked", this.analyticsPropsMethod())
			let shouldDelete = await deleteConfirmDialog({itemName: billingItem.isHourly ? "time entry" : "payment milestone"})
			if (shouldDelete) {
				this.billingData.removeBillingItemById(billingItem.id)
				this.onDataChanged()
			}
		},

		onAddMilestoneClicked() {
			let _ = this.$analyticManager.trackEvent("Add payment milestone clicked", this.analyticsPropsMethod())
			let item = new BillingItem();
			item.billingType = this.billingData.billingType
			this.billingData.billingItems.push(item)
			this.onDataChanged()
		},

		onTimeChanged(billingItem) {
			let _ = this.$analyticManager.trackEvent("Logged time changed", this.analyticsPropsMethod())
			this.onTimeEntryChanged(billingItem)
		},

		onTimeEntryChanged(billingItem) {
			if (!billingItem.isNameSetManually && billingItem.durationMs > 0) {
				billingItem.name = billingItem.durationFormatted()
			}
			this.onDataChanged()
		},

		hourlyOnAmountChanged(billingItem, event) {
			let _ = this.$analyticManager.trackEvent("Logged money amount changed", this.analyticsPropsMethod())
			console.log("hourlyOnAmountChanged")
			if (!this.billingData.hourlyRate) {
				billingItem.durationMs = 0
			} else {
				billingItem.durationMs = 60 * 60 * 1000 * billingItem.amount / this.billingData.hourlyRate
			}
			this.onTimeEntryChanged(billingItem)
		},


		onMilestonePicked(command) {

			console.log("onMilestonePicked: command = ", command)
			let itemId = command.itemId;
			let index = command.index
			let item = this.billingData.findBillingItemById(itemId);
			let milestonePicker = this.$refs.milestonePicker[index]
			switch (command.command) {
				case "byDate": {
					let date = moment(command.data)
					item.milestoneType = MilestoneType.DATE
					//order here matters to set the name correctly
					item.milestoneTs = date.valueOf()
					item.name = item.milestoneDateFormatted();
					break
				}
				case "byProgress": {
					item.milestoneType = MilestoneType.PROGRESS
					item.milestoneSectionId = command.data
					item.name = command.name;
					break
				}
			}

			milestonePicker.hide()
			this.onDataChanged()
		},

		onHourlyRateChanged() {
			let rate = this.billingData.hourlyRate
			let _ = this.$analyticManager.trackEvent("Hourly rate changed", {value: rate, ...this.analyticsPropsMethod()})
			this.onDataChanged()
		},
		onBillingTypeChanged(newVal) {
			if (this.paymentTypeIsFixed) {
				this.billingData.billingType = BillingType.FIXED
			} else {
				this.billingData.billingType = BillingType.RECURRING
			}
			let _ = this.$analyticManager.trackEvent("Billing type changed", this.analyticsPropsMethod())
			this.onDataChanged()
		},

		onDataChanged() {
			console.log("onDataChanged")
			this.billingData.invalidate(this.invoices);
			this.isEmitDataChangePending = true
			this.emitDataChangeDebounced()
		},
		emitDataChangeDebounced() {
			this.emitDataChange()
		},
		emitDataChange() {
			if (this.isEmitDataChangePending) {
				this.isEmitDataChangePending = false
				this.$emit("change", this.billingData, this)
			}
		},

		onInvoiceChanged(invoiceGroup) {
			invoiceGroup.invalidate()
			invoiceGroup.setCurrencyItem(this.currencyItemGlobal)
			this.emitInvoiceChange(invoiceGroup)
		},

		emitInvoiceChange(invoiceGroup) {
			this.$emit("invoiceGroupUpdated", invoiceGroup, this)
		},

		saveStarted() {
			console.log("saveStarted")
			if (this.$refs.saveIndicator) {
				console.log("saveStarted2")
				this.$refs.saveIndicator.show()
			}
		},
		saveSuccess() {
			console.log("saveSuccess")
			if (this.$refs.saveIndicator) {
				console.log("saveSuccess2")
				this.$refs.saveIndicator.hide()
			}
		},
		saveFailed() {
			if (this.$refs.saveIndicator) {
				this.$refs.saveIndicator.hideNoMessage()
			}
		},

		logClick(canEdit, billingItem) {
			console.log("canEdit = ", canEdit, ", billingItem = ", billingItem.id)
		},

		analyticsPropsMethod() {
			return {
				category: "Program billing panel",
				billing_type: this.billingData.isHourly ? "hourly" : "fixed",
				program_id: this.programItem.id,
				program_name: this.programItem.name,
			}
		},
	},

	computed: {
		paymentTypePanelName() {
			let defaultName = RecurringPaymentTypePanel.name

			if (!this.billingData) {
				return defaultName
			}
			if (this.billingData.isRecurring()) {
				return RecurringPaymentTypePanel.name
			}
			if (this.billingData.isFixed()) {
				return FixedPaymentTypePanel.name
			}
			if (this.billingData.isFixed()) {
				return HourlyPaymentTypePanel.name
			}
			return defaultName
		}
	},
}
</script>

<style>


</style>
